import React from "react";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as intchaine from "./interface-chaine";
import * as mem from "./recopieLotFournisseur";
import axios from "axios";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { ImSpinner3 } from "react-icons/im";
import "./App.css";
import { DEBUG } from "./utilitaires";

export default function AffichageLots() {
  const [LotsCount, setLotsCount] = useState(1);
  const [inputList, setInputList] = useState([]);
  const [stringListeLots, setStringListeLots] = useState("");
  const [isloading, setIsLoading] = useState(false);
  var stringLotstemp = "";
  var listeLotstemp = [];

  function handleListeOnChange(e, value) {
    e.preventDefault();
    stringLotstemp = value;
    setStringListeLots(value);
    if (value.length > 0) {
      if (value.charAt(value.length - 1) == "\n") {
        stringLotstemp = value.substring(0, value.length - 1);
        setStringListeLots(value.substring(0, value.length - 1));
        handleAffichage(e);
      }
    }
  }

  async function handleAffichage(e) {
    // setShow(false);
    e.preventDefault();
    if (DEBUG) console.log("stringLotstemps: ", stringListeLots);
    setIsLoading(true);
    setInputList([]);
    var listetemp = [];
    // on lit la liste des n° de lots entrés par l'utilisateur
    listeLotstemp = stringListeLots.split(",");
    try {
      for (let i in listeLotstemp) {
        listeLotstemp[i] = parseInt(listeLotstemp[i], 10);
        if (isNaN(listeLotstemp[i])) {
          throw "err";
        } else if (listeLotstemp[i] <= 0) {
          throw "err";
        } else if (!(await intchaine.existeLot(listeLotstemp[i]))) {
          throw "err";
        }
      }
      if (DEBUG) console.log("dans try, listeLotstemp: ", listeLotstemp);
    } catch (e) {
      if (DEBUG) console.log("dans catch, listeLotstemp: ", listeLotstemp);
      listetemp = [{ id: 1, jsx: <p>erreur dans la liste de lots</p> }];
      setInputList(listetemp);
      setIsLoading(false);
      return;
    }

    for (var i = 0; i < listeLotstemp.length; i++) {
      var infosLot = await intchaine.getInfosLot(listeLotstemp[i]);
      var {
        0: typeLot,
        1: nomLot,
        2: libelle,
        3: hashIm,
        4: descrL,
        5: argum,
        6: lotsFi,
        7: pourcentL,
        8: lotsP,
        9: idF,
        10: dateL,
        11: noteL,
        12: classementL,
        13: fabL,
        14: catL,
        15: paysL,
        16: pourcentExt,
        17: carbone,
        18: carboneTot,
        19: carbonePert,
        20: carboneRaj,
        21: DLC,
        22: rappel
      } = infosLot;
      var nomFournisseur = await intchaine.getNomFournisseurParNumF(idF);

      if (hashIm) {
        if (DEBUG)
          console.log("je vais appeler axios pour accès au serveur d'images");
        let res = null;
        try {
          res = await axios.get(
            "https://" + mem.addressIPRemoteimages + ":3008/download",
            // "https://" + mem.addressIPRemoteimages + ":3008/download",
            {
              responseType: "blob",
              params: { fichierImage: hashIm },
              timeout: 10000,
            }
          );
        } catch {
          alert("Problème avec le serveur d'images");
        }
        if (DEBUG) console.log(res.data);
        var dataUrl = URL.createObjectURL(res.data);
      }
      // on constitue la liste d'affichage
      listetemp = [
        ...listetemp,
        {
          id: listeLotstemp[i],
          jsx: (
            <>
              {/* <img src={dataUrl} alt="image produit" width={100} height={1S00} /> */}
              <br />
              {/* <h3>Informations sur les Lots</h3> */}
              <br />
              <p>
                <span style={{ color: "blue" }}>
                  Numero de lot dans la Blockchain:
                </span>{" "}
                {listeLotstemp[i]}
              </p>
              {hashIm && (
                <>
                  <p style={{ color: "blue" }}>Image:</p>
                  <span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <img src={dataUrl} alt="produit" width={100} height={100} />{" "}
                  </span>
                  <br />
                </>
              )}
              <br />
              {typeLot == "traceur" && (
                <>
                  <p style={{ color: "blue" }}>QR Code:</p>
                  <QRCodeCanvas
                    value={listeLotstemp[i].toString()}
                    size={256}
                    bgColor={"#ffffff"}
                    //fgColor={"#000000"}
                    fgColor={"red"}
                    level={"H"}
                    includeMargin={true}
                    imageSettings={{src:"text-to-image.png", height: 20, width: 20  ,excavate: true}}
                  />
                </>
              )}

              <p>
                <span style={{ color: "blue" }}>Type du Lot: </span>
                {typeLot}
              </p>
              <p>
                <span style={{ color: "blue" }}>
                  Numéro de Lot Fournisseur:{" "}
                </span>
                {nomLot}
              </p>
              <p>
                <span style={{ color: "blue" }}>Dénomination: </span>
                {libelle}
              </p>

              {typeLot == "traceur" && (
                <p>
                  <span style={{ color: "blue" }}>Fichier image: </span>
                  {hashIm}
                </p>
              )}

              <p style={{ whiteSpace: "pre-wrap" }}>
                <span style={{ color: "blue" }}>Description: </span>
                {descrL}
              </p>

              {typeLot == "traceur" && (
                <>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    <span style={{ color: "blue" }}>
                      Votre argumentaire pour ce Lot:{" "}
                    </span>
                    <br />
                    {argum}
                  </p>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    <span style={{ color: "blue" }}>
                      Pourcentage dans le contenu d'ingrédients extérieurs:{" "}
                    </span>
                    {pourcentExt}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Lots Fils: </span>
                    {lotsFi && lotsFi.join(", ")}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>
                      Pourcentages dans le contenu des Lots Fils:{" "}
                    </span>
                    {pourcentL && pourcentL.join()}
                  </p>
                </>
              )}

              <p>
                <span style={{ color: "blue" }}>Lots Pères: </span>
                {lotsP && lotsP.join()}
              </p>

              {typeLot == "traceur" && (
                <>
                  <p>
                    <span style={{ color: "blue" }}>Fournisseur: </span>
                    {nomFournisseur}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Note: </span>
                    {noteL}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Classement: </span>
                    {classementL}
                  </p>{" "}
                </>
              )}

              {typeLot == "fournisseur" && (
                <>
                  <p>
                    <span style={{ color: "blue" }}>Fabricant: </span>
                    {fabL}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Pays du Fabricant: </span>
                    {paysL}
                  </p>
                </>
              )}

              {typeLot == "traceur" && (
                <>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreinte carbone des Ingrédients internes:{" "}
                    </span>
                    {carbone}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreinte carbone Totale:{" "}
                    </span>
                    {carboneTot}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreinte carbone Totale pertinente:{" "}
                    </span>
                    {carbonePert.toString()}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreintes carbone rajoutées pour les lots fils:{" "}
                    </span>
                    {carboneRaj && carboneRaj.join(", ")}
                  </p>

                  <p>
                    <span style={{ color: "blue" }}>
                      Date Limite de consommation:{" "}
                    </span>
                    {DLC}
                  </p>

                  <p>
                    <span style={{ color: "blue" }}>
                      Rappel:{" "}
                    </span>
                    {rappel.toString()}
                  </p>                  
                </>
              )}

              {typeLot == "fournisseur" && (
                <>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreinte carbone:{" "}
                    </span>
                    {carbone}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>
                      Empreinte carbone Totale pertinente:{" "}
                    </span>
                    {carbonePert.toString()}
                  </p>
                </>
              )}

              <p>
                <span style={{ color: "blue" }}>
                  Date de Création sur la Blockchain:{" "}
                </span>
                {dateL}
              </p>
              <p>
                ---------------------------------------------------------------------------------
              </p>
              {/* <br /> */}
            </>
          ),
        },
      ];
    }
    setInputList(listetemp);
    setIsLoading(false);
  }

  // listetemp = [{id:1, jsx: (<p>erreur dans la liste de lots</p>)}]
  // setInputList(listetemp);

  function handleAutreAffichage() {
    // setShow(true);
  }

  const liste = inputList.map((inp) => <div key={inp.id}>{inp.jsx}</div>);

  return (
    <>
      {/* <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={handleAutreAffichage}
      >
        Autre selection de lots
      </Button>
      <br /> */}
      <br />
      <Form style={{ backgroundColor: "#d4d6d9" }}>
        <Form.Group className="mb-3">
          <Form.Label className="ps-2">Lots à afficher</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez la liste des lots à afficher"
            value={stringListeLots}
            onChange={(e) => handleListeOnChange(e, e.target.value)}
          />
        </Form.Group>
      </Form>
      <Button
        style={{ fontSize: 12, padding: 3 }}
        variant="outline-primary"
        onClick={handleAffichage}
      >
        Afficher les Lots
      </Button>
      <br />
      <br />

      {isloading && (
        <ImSpinner3
          color="grey"
          icon="spinner"
          className="spinner"
          style={{ height: 100, width: 100 }}
        />
      )}
      <div
        style={{
          paddingLeft: "60px",
          // marginLeft: "50px",
          // marginRight: "50px",
          borderStyle: "solid",
          borderWidth: "2px",
        }}
      >
        {liste}
      </div>
    </>
  );
}
